<template>
  <main id="content" class="flex-1 bg-[#FFF]">
    <div
      class="drop-shadow-lg border-b-4 justify-end bg-[#fffafd] p-4 lg:flex hidden"
    >
      <div class="lg:flex hidden">
        <div class="">
          <font-awesome-icon class="text-[#09518C]" icon="fa-solid fa-user" />
        </div>
        <div class="px-2 flex items-center justify-center">
          <span class="text-[#09518C] text-[12px]">
            Hi, {{ $store.state.getLoggedInUser?.name }}
          </span>
        </div>
      </div>
    </div>

    <div class="bg-[#fffafd] pt-12 px-[20px] lg:px-[40px] bg">
      <router-view />
    </div>
  </main>
</template>

<script>
export default {};
</script>

<style></style>
